const getters = {
  // main
  staticRoutes: state => state.main.staticRoutes,
  trendsRoutes: state => state.main.trendsRoutes,
  routesPathList: state => state.main.routesPathList,
  routesMap: state => state.main.routesMap,
  menuList: state => state.main.menuList,
  activeMenu: state => state.main.activeMenu,
  openOrgSteps: state => state.main.openOrgSteps,
  openProductSteps: state => state.main.openProductSteps,
  addOpenProductSteps: state => state.main.addOpenProductSteps,
  dicts: state => state.main.dicts,
  // 买入
  buyStepId: state => state.trade.buyStepId,
  buyFormObj: state => state.trade.buyFormObj,
  buyResult: state => state.trade.buyResult,
  // 赎回
  redeObj: state => state.trade.redeObj, // 当前赎回基金详情
  fundRedeObj: state => state.trade.fundRedeObj, // 当前赎回基金预览详情
  currRedeStepId: state => state.trade.currRedeStepId, // 当前交易结果步骤
  redeResult: state => state.trade.redeResult,
  // 转换
  currTransStepId: state => state.trade.currTransStepId, // 当前交易结果步骤
  transObj: state => state.trade.transObj, // 转换基金详情
  transFormObj: state => state.trade.transFormObj, // 转换基金表单详情
  // 文件下单
  fileStepId: state => state.trade.fileStepId, // 文件下单步骤
  fileCheckedList: state => state.trade.fileCheckedList, // 文件下单已选择列表
  fileOrderResult: state => state.trade.fileOrderResult, // 文件下单结果
  fileProtocalObj: state => state.trade.fileProtocalObj, // 信披留痕
  // 智能拆单
  currSplitStepId: state => state.trade.currSplitStepId, // 当前智能拆单交易结果步骤
  splitOrderList: state => state.trade.splitOrderList, // 智能拆单列表
  splitApplyList: state => state.trade.splitApplyList, 
  splitRemitBankList: state => state.trade.splitRemitBankList, 
  splitResult: state => state.trade.splitResult, // 智能拆单结果页
  splitAgreeObj: state => state.trade.splitAgreeObj,
  // 批量买入
  bulkStepId: state => state.trade.bulkStepId,
  bulkSelectedList: state =>  state.trade.bulkSelectedList,
  bulkResult: state => state.trade.bulkResult,
  // 批量赎回
  bulkRedeemStepId: state => state.trade.bulkRedeemStepId,
  bulkRedeemSelectedList: state =>  state.trade.bulkRedeemSelectedList,
  bulkRedeemResult: state => state.trade.bulkRedeemResult,
}

export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js